import React, { FC } from 'react'
// components
import Avatar from 'components/Avatar'
// types
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { style } from './sheet'
// utils
import cx from 'classnames'

interface Props {
  classes: Classes
  needEmail?: boolean
  photo: string
  role?: string
  name?: string
  isPopUp?: boolean
  email?: string
  firstName?: string
  lastName?: string
  isHideInfoOnXS?: boolean
  openMenu?: boolean
}

const UserDropdown: FC<Props> = ({
  classes,
  photo,
  role,
  name = '',
  isPopUp = false,
  isHideInfoOnXS = false,
  email,
  firstName = '',
  lastName = '',
  openMenu
}) => (
  <div className={cx(classes.profileInfo)}>
    <div className={cx(classes.photo)}>
      <Avatar src={photo} />
    </div>
    <div
      className={cx(classes.infoBlock, {
        [classes.hideOnXS]: isHideInfoOnXS
      })}
    >
      <div className="text-16 text-medium text-dark">
        {firstName} {lastName}
      </div>
      <div className="text-12 text-regular text-sub">{email}</div>
    </div>
  </div>
)

export default injectSheet(style)(UserDropdown)
